import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { Sgke140dComponent } from '../../pages/sgke140d/sgke140d.component';

@Component({
  selector: 'app-sgke140d-dialog',
  templateUrl: './sgke140d-dialog.component.html',
  styleUrl: './sgke140d-dialog.component.scss'
})
export class Sgke140dDialogComponent implements OnInit, OnDestroy {

  @ViewChild(Sgke140dComponent) sgke140dComponent!: Sgke140dComponent;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {{ 
   *           isEdit: boolean,
   *           rcvmnyReconciliationresultMno: string,
   *           rcvmnyreconciliationResultUpdatesequencenumber: string,
   *           feeMno: string,
   *           feeRrkno: string,
   *           feeUpdatesequencenumber: string,
   *         }} data 
   * @param {MatDialogRef<Sgke140DialogComponent>} dialogRef 
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      isEdit: boolean,
      rcvmnyReconciliationresultMno: string,
      rcvmnyreconciliationResultUpdatesequencenumber: string,
      feeMno: string,
      feeRrkno: string,
      feeUpdatesequencenumber: string,
    },
    public dialogRef: MatDialogRef<Sgke140dDialogComponent>) { }


  /**
   * 初期処理
   * @memberof Sgke140dDialogComponent
   */
  ngOnInit(): void {
  }

  /**
   * 購読解除
   * @memberof Sgke140dDialogComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * ダイアログクローズ処理
   * @param {any} data 
   * @memberof Sgke140dDialogComponent
   */
  closeDialog(data: any) {
    this.dialogRef.close(data);
  }

}
